import styled from 'styled-components';
import { marginMd } from 'assets/styled';

export const Form = styled.form`
  max-width: 100%;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin: ${marginMd} 0;
`;
